import type { AppState } from '../store'

export const selectAppIsLoaded = (state: AppState) => state.app.loaded
export const selectAppIsFailed = (state: AppState) => state.app.failed
